import { render, staticRenderFns } from "./EmpresaTable.vue?vue&type=template&id=27780912"
import script from "./EmpresaTable.vue?vue&type=script&lang=js"
export * from "./EmpresaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports